import { render, staticRenderFns } from "./AuctionAttr.vue?vue&type=template&id=aa6063e4&scoped=true"
import script from "./AuctionAttr.vue?vue&type=script&lang=js"
export * from "./AuctionAttr.vue?vue&type=script&lang=js"
import style0 from "./AuctionAttr.vue?vue&type=style&index=0&id=aa6063e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6063e4",
  null
  
)

export default component.exports